import requestBuilder from '@/requestBuilder'
import paramsBuilder from '@/paramsBuilder'

const api = {
  getCurrentUser () {
    return requestBuilder.get({ path: '/profile', kingsChat: true })
  },
  getCloudStorage () {
    return requestBuilder.get({ path: '/storage_space' })
  },
  getContacts () {
    const params = { includeUsers: true }
    return requestBuilder.get({ path: '/contacts', params: paramsBuilder(params), kingsChat: true })
  }
}

export default api
